import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "row full-width wrap self-center" };
const _hoisted_2 = { class: "col-12" };
const _hoisted_3 = { class: "text-body2 text-uppercase ellipsis-2-lines text-weight-bold" };
const _hoisted_4 = { class: "col-12" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_standard_avatar = _resolveComponent("standard-avatar");
    const _component_q_item_section = _resolveComponent("q-item-section");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_router_link = _resolveComponent("router-link");
    const _component_q_item = _resolveComponent("q-item");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_standard_options_list = _resolveComponent("standard-options-list");
    return (_openBlock(), _createElementBlock("div", null, [
        (_ctx.user)
            ? (_openBlock(), _createBlock(_component_q_item, { key: 0 }, {
                default: _withCtx(() => [
                    _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_standard_avatar, {
                                "allow-other-formats": "",
                                size: "3.5rem",
                                "original-size": "profile",
                                "size-type": "profile",
                                pic: _ctx.user.profile_img
                            }, null, 8, ["pic"])
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t('HELLO')) + ", " + _toDisplayString(_ctx.userMisc.name), 1)
                                ]),
                                _createElementVNode("div", _hoisted_4, [
                                    _createVNode(_component_router_link, {
                                        to: { name: 'Account Settings' },
                                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close')))
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_q_btn, {
                                                color: "primary",
                                                label: "Account",
                                                name: "Account",
                                                size: "sm"
                                            })
                                        ]),
                                        _: 1
                                    }),
                                    (_ctx.userAccDeletion)
                                        ? (_openBlock(), _createBlock(_component_router_link, {
                                            key: 0,
                                            to: { name: 'Account Settings' },
                                            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('close')))
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_q_btn, {
                                                    color: "accent",
                                                    label: "Pending Deletion",
                                                    name: "Pending Deletion",
                                                    size: "sm",
                                                    class: "q-ml-md account-btn"
                                                })
                                            ]),
                                            _: 1
                                        }))
                                        : (!_ctx.user.email_validated)
                                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                                key: 1,
                                                color: "accent",
                                                label: "Verify",
                                                name: "Verify",
                                                size: "sm",
                                                class: "q-ml-md account-btn",
                                                onClick: _ctx.verify
                                            }, null, 8, ["onClick"]))
                                            : _createCommentVNode("", true)
                                ])
                            ])
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }))
            : _createCommentVNode("", true),
        (_ctx.user)
            ? (_openBlock(), _createBlock(_component_q_separator, { key: 1 }))
            : _createCommentVNode("", true),
        _createVNode(_component_standard_options_list, {
            "app-icon-size": 14,
            "icon-right": "",
            "icon-size": "0.725rem"
        })
    ]));
}
